// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import ImageSlider from './components/Home';
import ContentSection from './components/ContentSection';
import Services from './components/Services';
import WhyChooseSection from './components/WhyChooseSection';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Legal Pages
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import VendorTerms from './pages/VendorTerms';
import HowItWorks from './pages/HowItWorks';
import AboutUsPage from './pages/AboutUsPage';   // ✅ NEW
import Vendorprivacy from './pages/Vendorprivacy';

// Blogs
import Blogs from './pages/Blogs';

function HomePage() {
  return (
    <>
      <ImageSlider />
      <ContentSection />
      <Services />
      <WhyChooseSection />
      <AboutUs />
      <ContactUs />
    </>
  );
}

function App() {
  return (
    <Router>
      <div>
        <ScrollToTop />
        <Navbar />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/about-us" element={<AboutUsPage />} />                {/* ✅ NEW */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} /> {/* ✅ matches live URL */}
          <Route path="/terms-conditions-partner" element={<VendorTerms />} />           {/* ✅ matches live URL */}
          <Route path="/privacy-policy-partner" element={<Vendorprivacy/>}/>
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;